import { Box, Button, Paper, Typography } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import ContentRight from "shared/molecules/content-right";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { makeStyles } from "@mui/styles";
import { indigo } from "@mui/material/colors";
import { useLazyQuery, useMutation } from "@apollo/client";
import entitesClient from "utils/graphql/entitiesClient";
import { useEffect, useState } from "react";
import Loader from "pages/build-test/loader";
import SectionTable from "shared/organisms/tables/table";
import NoDataFound from "shared/molecules/no-data";
import { GET_ACTUALSBDPROGRAM_LIST } from "utils/graphql/services/entities/queries";
import { table, tableRead } from "./helper";
import { ActualSbdProgramFilter } from "./filter";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { DELETE_ACTUAL_SBD_PROGRAM } from "utils/graphql/services/entities/mutations";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { academicTagsUser, checkFeatureAccess } from "utils/role-restriction/helper";

const useStyles: any = makeStyles((indigoTheme) => ({
  label: {
    textDecoration: "none",
    textAlign: "center",
    color: indigo[700],
    marginLeft: "80%",
  },
  Btn: {
    backgroundColor: "#3f50b5",
    color: "white",
    width: "90px",
  },
  BtnWrapper: {
    display: "flex",
    gap: "20px",
    justifyContent: "flex-end",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
}));

export function ActualSbdProgramEntitie() {
  const classes = useStyles();
  const [limit,setLimit]=useState(10);
  const [offset,setOffset]=useState(0);
  const [searchPayload,setSearchPayload]=useState({});
  const dispatch = useAppDispatch();
  const history = useHistory();

  const [getActualSbdProgram, { loading, error, data }] = useLazyQuery(
    GET_ACTUALSBDPROGRAM_LIST,
    {
      client: entitesClient,
    }
  );

  const [deleteActualSbdProgram, { loading:loadingD, error:errorD, data:dataD}] = useMutation(DELETE_ACTUAL_SBD_PROGRAM, {
    client: entitesClient,
  });

  const { profileData } = useAppSelector((state) => state.gmailLoginReducer);
  const { role: userRoleStr } = profileData;
  const userRole = userRoleStr?.split(",");

  const handleEdit = (objectId,isArchieve) => {
    history.push(`/entities/actual_sbd_program/edit?objectId=${objectId}&isArchived=${isArchieve}`);
  };
  
  const handleDeleteProgram = async (id) => {
    try {
      const response:any = await deleteActualSbdProgram({
        variables: { id: parseInt(id) }, // Ensure id is an integer
      });
  
      if (response?.data?.deleteActualSbdProgram?.success) {
        dispatch(snackbarRequest({ message: "Sbd Program deleted successfully" }));
        getActualSbdProgram({ variables: { filter: {limit:10,offset:0} } });
        setLimit(10);
        setOffset(0);
      } else {
        dispatch(snackbarRequest({ message: `${response?.errorReason}`,type: "error"  }));

      }
    } catch (err) {
      dispatch(snackbarRequest({ message: `${err}`,type: "error"  }));

    }
  };

  useEffect(() => {
    getActualSbdProgram({ variables: { filter: {...searchPayload,limit,offset} } });
  }, [searchPayload,limit,offset]);

  const hasModificationAccess = checkFeatureAccess(
    userRole,academicTagsUser.ACADEMIC_TAGS_READ_WRITE
  );    

  return (
    <div>
      {hasModificationAccess && (
        <ContentRight>
          <Link to="actual_sbd_program/create" className={classes.label}>
            <Button variant="contained">Create Program</Button>
          </Link>
        </ContentRight>
      )}
      <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
        Sbd Program
      </TypographyHeading>
      <ActualSbdProgramFilter
        setSearchPayload={setSearchPayload}
        setOffset={setOffset}
      />
      <Paper elevation={2} sx={{ px: 2, pb: 4, paddingTop: 4, mt: 2 }}>
        <div>
          {loading && <Loader />}
          {!loading && data?.getActualSbdProgram.length > 0 ? (
            <SectionTable
              data={data?.getActualSbdProgram}
              table={hasModificationAccess===true?table:tableRead}
              id="id"
              name="id"
              handleEdit={handleEdit}
              handleDelete={handleDeleteProgram}
              rowsPerPageCount={10}
              style="false"
              totlaRecords={0}
              paginationSegment="false"
              viewSecondaryData="false"
            />
          ) : (
            <div>{!loading && <NoDataFound message="No Data" />}</div>
          )}
        </div>
        <Box className={classes.BtnWrapper}>
          <Button
            onClick={() => {
              setOffset(offset - 10);
            }}
            className={classes.Btn}
            disabled={offset == 0}
            variant="contained"
            size="medium"
          >
            prev
          </Button>
          <Button
            onClick={() => {
              setOffset(offset + 10);
            }}
            className={classes.Btn}
            disabled={data?.getActualSbdProgram?.length <= 9}
            variant="contained"
            size="medium"
          >
            next
          </Button>
        </Box>
      </Paper>
    </div>
  );
}
